export default {
  namespaced: true,
  state: {
    userDeviceInfo: {},
  },
  getters: {
    getUserDeviceInfo(state) {
      return state.userDeviceInfo;
    },
  },
  actions: {
    updateUserDeviceInfo({ commit }, data) {
      commit('UPDATE_USER_DEVICE_INFO', data);
    },
  },
  mutations: {
    UPDATE_USER_DEVICE_INFO(state, data) {
      state.userDeviceInfo = data;
    },
  },
};
